import { type CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { xs, md },
} = constants.breakpoints;

const { ui } = constants.colors;
const neutral600 = ui.neutral[600];

export const headerContainerCss: CSSObject = {
  padding: "0px",
  width: "100%",
  display: "flex",
  flexDirection: "column-reverse",
  gap: "48px",
  [mq.downTo(md)]: {
    flexDirection: "row",
  },
};

export const headerContentInfoCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

export const headerContentTop: CSSObject = {
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
};

export const descriptionCss: CSSObject = {
  marginTop: "8px",
  width: "100%",
  marginBottom: "24px",
  color: neutral600,
  maxWidth: "800px",
};

export const headingCss: CSSObject = {
  fontFamily: "Circular",
  margin: "0px",
  lineHeight: "2.0rem",
  fontSize: "24px",
  [mq.downTo(xs)]: {
    lineHeight: "2.5rem",
    fontSize: "32px",
  },
};
